<template>
  <div id="container" :type="glb.pageType">
    <div class="page page-sitemap" v-ga:request="{pageType: glb.pageType, state: sitemap}" v-ga:page="{pageType: glb.pageType, glb: glb, state: sitemap}">
      <mvtHeader :geoInfo="geo"/>
      <div v-if="sitemap.pageTitle" class="bg-brand flex xs-grid-cols-1 inline gap-3 vertical">
        <h1 class="f0 text-bold text-center" v-html="sitemap.pageTitle"></h1>
      </div>
      <sitemapBreadcrumb :breadCrumb="getBreadCrumbData" />
      <section v-if="sitemap.paragarphics">
        <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3" >
          <p v-if="sitemap.paragarphics" v-html="sitemap.paragarphics"></p>
        </div>
      </section>
      <section v-if="letterLinkList && letterLinkList.length">
        <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
          <div class="panel-pagination"  v-if="letterLinkList && letterLinkList.length">
            <div class="pagination-list">
              <template v-for="(item,index) in letterLinkList">
                <a
                    :class="sitemap.letter && sitemap.letter.toUpperCase()===item.letter ? 'selected' : 'link'"
                    :href="item.sitemapUrl"
                    v-if="item.countAvailable"
                    :key="index"
                >
                  {{ item.letter }}
                </a>
              </template>
            </div>
          </div>
        </div>
      </section>
      <section :class="isNewSitemapTemplate? 'sitemap-grid' : 'grid grid-cols-1 gap-4'">
        <template v-if="sitemap.dataList && sitemap.dataList.length" v-for="(list,index) in sitemap.dataList">
          <div :class="isNewSitemapTemplate ? (list.isMain ? 'main-section' : list.isAside ? 'aside-section' : '') : 'grid fixed fixed-max-sm xs-grid-cols-1 gap-3'">
            <mvtCollapsibleLinks
                :title="list.title"
                :titleTag="sitemap.pageType === 'vsitemap_przipcode' ? 'h1' : 'h2'"
                titleClass="f3 text-capitalize text-bold p-y-2"
                :links='formatDataList(list.data)'
                :key="index"
                :initialExpandedState="true"
                :limit="sitemap.pageType === 'vsitemap_statenewest' ? 75 : undefined"
                :forceExpanded="true"
                :numCols="isNewSitemapTemplate? list.numCols : undefined"
                :addLinkGridItem="!isNewSitemapTemplate"
            >
              <template v-slot:link>
                <a v-if="list.showMoreNeighborhood && !isNewSitemapTemplate" role="button" aria-label="See all neighborhoods" class="more link" :href="list.showMoreNeighborhood.href">{{ list.showMoreNeighborhood.text }}</a>
              </template>
              <template v-slot:reorgLink="{ reorgItem, index }">
                <a v-if="isValidUrl(reorgItem.nameForUrl)" class="link" :href="glb.appUrl + reorgItem.nameForUrl" :key="`single-${index}`">{{ reorgItem.displayName }}
                  <span class="f7" v-if="list.showListingCount">{{ list.showListingCount ? `(${reorgItem.listingCount})` : '' }}</span>
                </a>
                <template v-if="list.newUrls">
                  <a class="link" :href="glb.appUrl + reorgItem.nameForUrl + 'new/'" :key="`single-${index}`"> (newest homes) </a>
                </template>
              </template>
            </mvtCollapsibleLinks>
          </div>
          <mvtPagination
            v-if="sitemap.pages && sitemap.pages.length > 3 && list.pagination && !isNewSitemapTemplate"
            :pageCount='pageCount'
            :activePageNumber='sitemap.displayPageIndex'
            :baseUrl='baseUrl'
            :pageDisplayLimit="pageDisplayLimit"
          />
        </template>
      </section>
      <section v-if="sitemap.pageType === 'vsitemap_states'">
        <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
          <mvtCollapsibleLinks
              title="Browse More Real Estate:"
              titleClass="f3 text-capitalize text-bold p-y-2"
              :links='getSitemapLinks'
              :forceExpanded="true"
          />
        </div>
      </section>
      <mvtFooter :geoInfo="geo"/>
    </div>
    <mvtPopSignin />
    <mvtDialogCenter></mvtDialogCenter>
  </div>
</template>

<script src="./page-sitemap.js"></script>
<style lang="scss">
@use "./page-sitemap.scss" as *;
</style>